import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Leading.css";

gsap.registerPlugin(ScrollTrigger);

const Leading = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const applyAnimations = () => {
      const textElements = textRef.current.querySelectorAll(
        ".paragraph-ll, .heading-ll, .subheading-ll",
      );
      const imageElement = imageRef.current;

      const isMobileOrTablet = window.innerWidth <= 768;

      // Clear previous ScrollTriggers
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

      // Animation for right-side content
      gsap.fromTo(
        textElements,
        { y: isMobileOrTablet ? 10 : 0, opacity: 0 },
        {
          y: isMobileOrTablet ? 30 : 100,
          opacity: 1,
          duration: 2,
          ease: "power3.out",
          stagger: { each: 0.4 },
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 85%",
            end: "bottom 20%",
            scrub: 1,
          },
        },
      );

      // Animation for left-side image
      gsap.fromTo(
        imageElement,
        { y: isMobileOrTablet ? 0 : -80, opacity: 0 },
        {
          y: isMobileOrTablet ? 20 : 50,
          opacity: 1,
          duration: 2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: imageRef.current,
            start: "top 85%",
            end: "bottom 20%",
            scrub: 1,
          },
        },
      );
    };

    // Apply animations initially
    applyAnimations();

    // Reapply animations on resize
    window.addEventListener("resize", applyAnimations);

    return () => {
      // Cleanup on unmount
      window.removeEventListener("resize", applyAnimations);
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className="leading-ll">
      <div className="right-ll" ref={textRef}>
        <h1 className="heading-ll">About CA & Associates</h1>
        <p className="paragraph-ll">
          At CA & Associates, we are dedicated to providing top-tier legal and
          financial services to help you navigate and resolve complex
          challenges. Our team of experienced professionals offers a wide range
          of expertise, from corporate law and tax advisory.
        </p>
        <p className="paragraph-ll">
          With a client-first approach, our professionals are not only experts
          in their respective fields but also compassionate advisors who
          understand the stress financial and legal matters can bring.
        </p>
      </div>
      <div className="left-ll">
        <img
          src="/l2.webp"
          alt="Legal Service"
          className="left-image-ll"
          ref={imageRef}
        />
      </div>
    </section>
  );
};

export default Leading;
